import * as React from "react";
import App from "./App";

class PublicApp extends React.Component<any,any> {
  public render() {
    return (
      <React.Fragment>
        <App {...this.props}/>
      </React.Fragment>
    );
  }
}

export default PublicApp;
